module.exports = __webpack_public_path__ + "img/P7.1ce8bd00.jpg";